// extracted by mini-css-extract-plugin
export default {"container":"applications-components-HeaderApp-components-VTBCartContainer-vtb-cart-container-module__container","sticky":"applications-components-HeaderApp-components-VTBCartContainer-vtb-cart-container-module__sticky"};
    if(module.hot) {
      // 1782397803622
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  